import { compose, withProps, branch, renderComponent, setPropTypes } from 'recompose';
import PropTypes from 'prop-types';
import PaymentPending from "./PaymentPending";
import { formatDate } from "../../../util/datetime";
var enhancer = compose(withProps(function (_ref) {
  var info = _ref.info;
  var date = info && info.paid_at;
  var formattedDate = formatDate(date, 'MMMM DD, YYYY');
  return {
    formattedDate: formattedDate
  };
}), branch(function (_ref2) {
  var info = _ref2.info;
  return !info || !info.paid;
}, renderComponent(PaymentPending)), setPropTypes({
  appPrice: PropTypes.string,
  formattedDate: PropTypes.string,
  info: PropTypes.object
}));
export default enhancer;